import React, { useEffect } from "react";
import {
  StyleSheet,
  SafeAreaView,
  Switch,
  Platform,
  useWindowDimensions,
  Text,
} from "react-native";
import { Card, Checkbox } from "react-native-paper";
import CustomButton from "../../CustomButton/CustomButton";
import CustomDropDown from "../../CustomDropDown/CustomDropdown";
import CustomInput from "../../CustomInput/CustomInput";
import CustomLabel from "../../CustomLabel/CustomLabel";
import CustomNumericInput from "../../CustomNumericInput/CustomNumericInput";
import { useTheme } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import CustomQuestionLine from "../QuestionLine/CustomQuestionLine";

const CustomQuestion = ({
  Stages,
  currentStage,
  handleQuestionChange,
  handleQuestInstructionsChange,
  input_type_name,
  questionIndex,
  sectionId,
  sectionIndex,
  handleQuestionTypeChange,
  question_required_yn,
  questionName,
  questionInstructions,
  handleQuestionLineChange,
  handleTccQuestionLineAdd,
  handleDeleteTccAnswerGroup,
  questionId,
  questionOptionResponseList,
  questionLines,
  questionLinesStage1,
  questionLinesStage2,
  questionLinesStage3,
  quest_controls,
  handleQuestionLineAdd,
  singleQuestion,
  Editable = 1,
  isResponse = 0,
  isResult = 0,
  isAnalytics = 0,
  toView = 0,
  response_yn,
  questweight,
  handleQuestionLineRemove,
  handleQuestionLineResp,
  sectionQuantitative,
  assm_submitted,
}) => {

  const { t } = useTranslation();
  const { width, height } = useWindowDimensions();

  const questionTypeList = [
    { label: t("common:text"), value: "Text" },
    { label: t("common:Slider"), value: "Slider" },
    { label: t("common:Essay"), value: "Essay" },
    { label: t("common:Scale"), value: "Scale" },
    { label: t("common:ScaleNa"), value: "Scale With n/a" },
    { label: t("common:Boxes"), value: "Boxes" },
    { label: t("common:TableCustomControls"), value: "TCC" },
  ];
  const { colors } = useTheme();
  const styles = makeStyles(colors, width, height);

  const getBaseSequenceLength = (questionLines) => {
    if (!questionLines || questionLines.length === 0) return 0;
    let baseLength = 1; // at least 1 line expected
    for (let i = 1; i < questionLines.length; i++) {
      if (questionLines[i].question_id === 0) break;
      baseLength++;
    }
    return baseLength;
  };
  const baseSequenceLength = getBaseSequenceLength(questionLines);

  useEffect(() => {
    // * No need to do anything here
  }, [width, height]);

  useEffect(() => {
    // * No need to do anything here
  }, [width, height]);

  if (singleQuestion.isQuestionCover)
    return (<></>)

  return (
    <SafeAreaView style={styles.main}>
      <SafeAreaView style={styles.widthDirection}>
        {/* //* Question Name and insrtuctions */}
        <SafeAreaView style={toView ? styles.fullWidth : styles.seventyWidth}>
          <SafeAreaView style={{ flexDirection: 'row', justifyContent: 'flex-end', paddingHorizontal: 16 }}>
            {question_required_yn && toView && (
              <Text style={{ color: 'red', fontSize: 30, fontWeight: 'bold' }}>*</Text>
            )}
          </SafeAreaView>
          <CustomInput
            value={questionName === "" ? "" : questionName}
            editable={toView == 1 || Editable === 0 ? false : true}
            setValue={(e) =>
              handleQuestionChange(e, singleQuestion.id, sectionId, sectionIndex)
            }
            type="SURVEYHEADER1"
            placeholder={questionName === "" ? t("common:questionTitle") : (question_required_yn ? questionName + '*' : questionName)}
          />
          {(!toView || questionInstructions !== "") && (
            <CustomInput
              value={questionInstructions === "" ? "" : questionInstructions}
              editable={toView == 1 || Editable === 0 ? false : true}
              setValue={(e) =>
                handleQuestInstructionsChange(e, questionIndex, sectionIndex)
              }
              type="SURVEYHEADER2"
              placeholder={
                questionInstructions === ""
                  ? "Question Instructions"
                  : questionInstructions
              }
            />
          )}
        </SafeAreaView>
        {/* //* Create Question Customizations, allow multiple answers, change quesiton type and question weight -- Only Assessment Creation Show */}
        {toView === 0 && (
          <SafeAreaView style={styles.dropDownView}>
            <SafeAreaView style={styles.row}>
              <CustomLabel
                value={t("common:questionTypeSelect")}
                type="ASSMMINOR"
              />
              <CustomDropDown
                disabled={Editable ? false : true}
                defValue={input_type_name}
                options={questionTypeList}
                value={input_type_name}
                setValue={(e) =>
                  handleQuestionTypeChange(e, questionIndex, sectionIndex)
                }
                type="ASSM"
              />
            </SafeAreaView>
            <SafeAreaView style={styles.row}>
              <CustomLabel
                value={t("common:requiredQuestion")}
                type="ASSMMINOR"
              />
              <Switch
                trackColor={{ false: "#767577", true: "#81b0ff" }}
                thumbColor={question_required_yn == 1 ? "#f5dd4b" : "#f4f3f4"}
                ios_backgroundColor="#3e3e3e"
                onValueChange={Editable ? (newValue) => handleQuestionChange(newValue, singleQuestion.id, sectionId, sectionIndex, 0, 1) : () => { }}
                value={question_required_yn == 1 ? true : false}
              />
            </SafeAreaView>
            {sectionQuantitative === true && input_type_name !== "" && input_type_name !== "Text" && input_type_name !== "Essay" && toView === 0 ? (
              <SafeAreaView style={styles.row}>
                <CustomLabel value={t("common:weight")} type="ASSMMINOR" />
                {/* {weightMessage && <CustomLabel value={t("common:weightMessage")} type="ASSM" />} */}
                <CustomNumericInput value={questweight !== undefined ? questweight : 0}
                  setValue={(weight) => handleQuestionChange('', singleQuestion.id, sectionId, sectionIndex, 0, 0, weight)}
                  editable={Editable === 0 ? false : true}
                  min={0}
                  max={100}
                  type="SM_MYPROFILE"
                />
              </SafeAreaView>
            ) : (
              <></>
            )}
          </SafeAreaView>
        )}
      </SafeAreaView>
      {/*   // * quest_controls is only defined on response. For the boxes instead of adding all the question lines separately
            // * we parse them together to generate moveable boxes with the question lines that can be alinged below disagree / agree columns
            // * for this we cannot add the previous steps. */ }
      {quest_controls === 'boxes' ?
        <CustomQuestionLine
          sectiond_id={sectionId}
          questionId={questionId}
          question_input_type_name={input_type_name}
          handleQuestionLineChange={handleQuestionLineChange}
          handleQuestionLineAdd={handleQuestionLineAdd}
          handleQuestionLineResp={handleQuestionLineResp}
          isResult={isResult}
          questionIndex={questionIndex}
          sectionIndex={sectionIndex}
          questweight={questweight}
          isQuantitative={sectionQuantitative}
          Editable={Editable}
          toView={toView}
          currentStage={currentStage}
          Stages={Stages}
          assm_submitted={assm_submitted}
          questionLines={questionLines}
          questionLines1={questionLinesStage1 === undefined ? undefined : questionLinesStage1}
          questionLines2={questionLinesStage2 === undefined ? undefined : questionLinesStage2}
          questionLines3={questionLinesStage3 === undefined ? undefined : questionLinesStage3}
          quest_controls={quest_controls}
        /> :
        questionLines.map((singleQuestionLine, index) => {
          const isExtraAnswerLine = baseSequenceLength < questionLines.length;
          const isEndOfAnswerGroup = (index + 1) % baseSequenceLength === 0;
          // console.log(questionLines)
          if (isExtraAnswerLine && Editable === 1) {
            return (
              <SafeAreaView>
                <SafeAreaView style={styles.trash}>
                  <CustomQuestionLine
                    sectiond_id={sectionId}
                    questionId={questionId}
                    singleQuestionLine={singleQuestionLine}
                    singleQuestionLineStage1={questionLinesStage1 === undefined ? undefined : questionLinesStage1[index]}
                    singleQuestionLineStage2={questionLinesStage2 === undefined ? undefined : questionLinesStage2[index]}
                    singleQuestionLineStage3={questionLinesStage3 === undefined ? undefined : questionLinesStage3[index]}
                    question_input_type_name={input_type_name}
                    handleQuestionLineChange={handleQuestionLineChange}
                    handleQuestionLineAdd={handleQuestionLineAdd}
                    handleQuestionLineResp={handleQuestionLineResp}
                    question_line_respUI={singleQuestionLine.question_line_respUI}
                    isResult={isResult}
                    questionIndex={questionIndex}
                    sectionIndex={sectionIndex}
                    questweight={questweight}
                    isQuantitative={sectionQuantitative}
                    index={index}
                    Editable={Editable}
                    questionLineName={singleQuestionLine.question_line_description}
                    toView={toView}
                    currentStage={currentStage}
                    Stages={Stages}
                    assm_submitted={assm_submitted}
                  />
                  {isExtraAnswerLine && isEndOfAnswerGroup && Editable === 1 && (
                    <SafeAreaView style={styles.trash}>
                      <CustomButton
                        onPress={() => handleDeleteTccAnswerGroup(sectionId, index, baseSequenceLength)}
                        iconName="trash-outline"
                        show="HOME_BELL"
                        type="HOME_BELL"
                        textTop="2"
                        sz={40}
                      />
                    </SafeAreaView>
                  )}
                </SafeAreaView>
              </SafeAreaView>
            );
          } else {
            return (
              <SafeAreaView style={styles.submain}>
                {/* // * For adding new question lines we can add on Create/Edit Assessment and also on when Completing Survey Table Custom Controls question   */}
                {(!toView && Editable === 1) && questionLines.length !== 1 &&
                  <SafeAreaView style={styles.trash}>
                    <CustomButton
                      onPress={() => handleQuestionLineRemove(index, questionIndex, sectionIndex)}
                      iconName="trash-outline"
                      show="PART"
                      type="PART"
                      textTop="0"
                      sz={30}
                    />
                  </SafeAreaView>
                }
                <CustomQuestionLine
                  sectiond_id={sectionId}
                  questionId={questionId}
                  singleQuestionLine={singleQuestionLine}
                  singleQuestionLineStage1={questionLinesStage1 === undefined ? undefined : questionLinesStage1[index]}
                  singleQuestionLineStage2={questionLinesStage2 === undefined ? undefined : questionLinesStage2[index]}
                  singleQuestionLineStage3={questionLinesStage3 === undefined ? undefined : questionLinesStage3[index]}
                  question_input_type_name={input_type_name}
                  handleQuestionLineChange={handleQuestionLineChange}
                  handleQuestionLineAdd={handleQuestionLineAdd}
                  handleQuestionLineResp={handleQuestionLineResp}
                  question_line_respUI={questionLines[index].question_line_respUI}
                  isResult={isResult}
                  questionIndex={questionIndex}
                  sectionIndex={sectionIndex}
                  questweight={questweight}
                  isQuantitative={sectionQuantitative}
                  index={index}
                  Editable={Editable}
                  questionLineName={
                    questionLines[index].question_line_description
                  } // Update the property access to singleQuestion
                  toView={toView}
                  currentStage={currentStage}
                  Stages={Stages}
                  assm_submitted={assm_submitted}
                />
              </SafeAreaView>
            )
          }
        }
        )}
      {/* //* This is a button that creates a set of question lines during response in case of the question controls to be TableCustomControl*/}
      {((assm_submitted !== undefined ? !assm_submitted : false) && quest_controls === 'TableCustomControls') && (
        <SafeAreaView style={styles.twentyFiveWidthFlexEnd} >
          {questionLines.length !== 1 && (
            <CustomButton
              text={Platform.OS === "web" && width > 1300 ? t("common:addTccQuestionLine") : ""}
              onPress={() => handleTccQuestionLineAdd(sectionId, questionId)}
              iconName="add-outline"
              show="ASSM"
              type="ASSM"
              textTop="0"
              sz={25}
              isGradient={true}
            />
          )}
        </SafeAreaView>
      )}
    </SafeAreaView>
  );
};

const makeStyles = (colors, width, height) =>
  StyleSheet.create({
    main: {
      flex: 1,
    },
    submain: {
      flex: 1,
      flexDirection: 'row',
      // justifyContent: 'space-between'
      // alignSelf:'center',
    },
    dropDownView: {
      flex: 1,
      alignSelf: "flex-start",
      justifyContent: "flex-start",
    },
    seventyWidth: {
      width: "70%",
      alignSelf: "center",
    },
    twentyFiveWidth: {
      width: "25%",
    },
    twentyFiveWidthFlexEnd: {
      width: "25%",
      flexDirection: 'row-reverse',
      alignSelf: 'flex-end',
      justifyContent: 'flex-end'
    },
    fullWidth: {
      flex: 1,
      flexWrap: "wrap",
      alignSelf: "center",
    },
    row: {
      flex: 1,
      flexDirection: "row",
      margin: 10,
      alignItems: "center",
      justifyContent: "space-evenly",
    },
    widthDirection: {
      margin: 10,
      justifyContent: 'flex-start',
      flexDirection: Platform.OS === "web" && width > 800 ? "row" : "column",
    },
    trash: {
      marginTop: 30,
    },
    line: {
      borderBottomColor: colors.buttons_primary,
      borderBottomWidth: StyleSheet.hairlineWidth,
      marginTop: "1%",
      marginBottom: "1%",
    },
  });

export default CustomQuestion;
